import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { setToken } from "../../core/auth/auth.service";
import MfaComponent from "../../core/components/mfa/mfa.component";
import ModalComponent from "../../core/components/modal/modal.component";
import "./login.scss";
import { Helmet } from "react-helmet-async";
import Cookies from "universal-cookie";
import Alert from "react-bootstrap/Alert";
import axios from "axios";

const LoginComponent: React.FC = () => {
  const baseURL = process.env.REACT_APP_BASE_URL_CUSTOM_AUTH;
  const currentEnvironment = process.env.REACT_APP_CURRENT_ENVIRONMENT;

  const navigate = useNavigate();
  const [isOTPModalOpen, setIsOtpModalOpen] = useState<boolean>(false);

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const [isBannerVisible, setIsBannerVisible] = useState<boolean>(false);
  const [bannerData, setBannerData] = useState<any>({});

  const onSubmitMfaOtp = () => {
    // setToken(localStorage.getItem("temp-token"));
    localStorage.setItem("isLogout", JSON.stringify(false));
    setIsOtpModalOpen(false);

    const redirectUrl = localStorage.getItem("postLoginRedirect");

    if (redirectUrl) {
      localStorage.removeItem("postLoginRedirect");
      window.location.href = redirectUrl;
    } else {
      navigate("/dashboard");
    }
  };

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  /*   async function signInVia(provider: string) {
    try {
      await openExternalLoginPopup(provider);
    } catch (e) {
      console.error("Error during authentication", e);
    }
  } */

  const handleCloseOtpModal = () => {
    setIsOtpModalOpen(false);
  };

  useEffect(() => {
    const cookies = new Cookies();
    // Frame-busting script to prevent clickjacking
    try {
      // Use window.self and window.top instead of direct globals
      const inFrame =
        window.self !== window.top || document !== window.top?.document;

      if (inFrame && window.top) {
        // Use optional chaining and proper assignment
        window.top.location.href = window.self.location.href;
      }
    } catch (e) {
      // Fallback for strict same-origin policies
      if (window.location !== window.parent.location) {
        window.parent.location.href = window.location.href;
      }
    }

    localStorage.setItem("isLogout", JSON.stringify(true));
    cookies.remove("hdb-token", { path: "/" });
    localStorage.removeItem("lastSessionCount");

    axios
      .get(`${baseURL}/getbanner`)
      .then((res) => {
        setBannerData(res.data);
        setIsBannerVisible(res.data?.isBannerVisible);
      })
      .catch((err) => {
        console.error("Error fetching banner:", err);
        setIsBannerVisible(false);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>Login | SLP</title>
        <meta httpEquiv="X-Frame-Options" content="DENY" />
        <meta
          httpEquiv="Content-Security-Policy"
          content="frame-ancestors 'none'"
        />
      </Helmet>

      <div className="login-page-backsplash">
        {isBannerVisible ? (
          <Alert
            variant="warning"
            style={{
              width: "98%",
              marginTop: "20px",
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: bannerData?.message }} />

            {/* <div style={{ marginBottom: "20px" }}>
              <Alert.Heading style={{ marginBottom: "15px" }}>
                [SLP Announcement] Scheduled Maintenance for HDB Smart Lighting
                Platform (SLP)
              </Alert.Heading>

              <div style={{ marginBottom: "20px" }}>
                To enhance the reliability and performance of the HDB Smart
                Lighting Platform (SLP), scheduled maintenance will be carried
                out as follows:
              </div>

              <div style={{ marginBottom: "5px" }}>
                HDB Smart Lighting Platform (SLP)
              </div>
              <div style={{ marginBottom: "5px" }}>
                Date: Wednesday, 6 August 2025
              </div>
              <div style={{ marginBottom: "20px" }}>
                Time: 0200 hours to 0500 hours SGT
              </div>
              <div style={{ marginBottom: "5px" }}>
                AWS Direct Connect Service GCC 2.0 (GCP)
              </div>
              <div style={{ marginBottom: "5px" }}>
                Date: Tuesday, 5 August 2025
              </div>
              <div style={{ marginBottom: "20px" }}>
                Time: 0000 hours to 0400 hours SGT
              </div>

              <div style={{ marginBottom: "5px" }}>Expected Impact</div>
              <div>
                During this maintenance period, the SLP service may be
                unavailable. We recommend users to plan their activities
                accordingly.
              </div>
            </div> */}
          </Alert>
        ) : (
          <div className="login-page-backsplash-without-banner"></div>
        )}
        <div
          className="bg-card shadow-lg login-card"
        >
          <div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "700",
              }}
            >
              Smart Lighting System
            </div>
            <div
              className="mt-1"
              style={{
                fontSize: "13px",
              }}
            >
              Select account to login
            </div>
          </div>

          <Button
            variant="primary"
            className="btn mt-5"
            onClick={() => {
              localStorage.setItem("customAuthType", "AD");
              window.location.href = `${baseURL}/login?provider=azure`;
            }}
          >
            {currentEnvironment == "sit"
              ? "Sign in with Azure AD"
              : " Sign in with WOG ADFS"}
          </Button>
          <Button
            variant="default"
            className="btn  mt-3"
            onClick={() => {
              localStorage.setItem("customAuthType", "HDB");
              window.location.href = `${baseURL}/login?provider=hdbiam`;
            }}
          >
            {currentEnvironment == "sit"
              ? "Sign in with Mockpass"
              : "Sign in with Singpass"}
          </Button>
        </div>

        {/* <div className="header-container">
        <div className="title-container"></div>
      </div>
        <div className="page">
        <div className="page-container mt-4">
          <div className="jumbotron">
            <div role="alert" className="fade alert alert-info show">
              <div className="alert-heading h4">
                <i className="fa fa-info-circle mr-2"></i>
                Important notes
              </div>
              <div className="admonitionContent_vXIg">
                <ListGroup as="ol" numbered>
                  <ListGroup.Item as="li" className="border-0 px-5">
                    Logging into your session will take 1 minute to complete. By
                    proceeding, we shall assume that you have read and agreed to
                    the <a href="#">Terms of Use</a>.
                  </ListGroup.Item>
                  <ListGroup.Item as="li" className="border-0 px-5">
                    To end the session, simply click on the Logout button.
                  </ListGroup.Item>
                  <ListGroup.Item as="li" className="border-0 px-5">
                    You have forgotten your Singpass password, please reset it
                    using the <a href="#">Singpass online</a> request service.
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </div>
            <div className="login pt-4">
              <h4 className="font-blod">For individual users</h4>
              <p>To local entities/individuals without Registered UEN.</p>
              <div className="flex items-center">
                <B2Button
                  variant="primary"
                  className="btn"
                  onClick={() => {
                    localStorage.setItem("customAuthType", "AD");
                    window.location.href = `${baseURL}/login?provider=azure`;
                  }}
                >
                  Sign in with WOG ADFS
                </B2Button>
                <span className="mx-3">or</span>
                <B2Button
                  variant="primary"
                  className="btn"
                  onClick={() => {
                    localStorage.setItem("customAuthType", "HDB");
                    window.location.href = `${baseURL}/login?provider=hdbiam`;
                  }}
                >
                  Sign in with Singpass
                </B2Button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={true}
            backdropClassName="custom-backdrop"
            isClosable={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default LoginComponent;
